import Pedido, {
  FiltroPesquisarPedido,
} from "../Components/Shared/Interfaces/Pedido";
import { ServiceBase } from "./ServiceBase";

export class OrcamentoService extends ServiceBase {
  async postOrcamento(url: string, body: Pedido) {
    return this.post(url, body);
  }

  async putOrcamento(url: string, body: Pedido) {
    return this.put(url, body);
  }

  async getAll(url: string) {
    return this.get(url);
  }

  async deleteItem(orcamentoID: string) {
    return this.delete(`/api/Orcamento/Deletar/${orcamentoID}`);
  }

  async buscarPor(body: FiltroPesquisarPedido) {
    let url = "/api/Orcamento/BuscarPor";
    return this.post(url, body);
  }

}
